import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPencil(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.1197 6.9718L15.5828 4.50878C16.2611 3.83041 17.361 3.83041 18.0394 4.50878L19.4912 5.96062C20.1696 6.639 20.1696 7.73887 19.4912 8.41724L17.0282 10.8803M13.1197 6.9718L4.50878 15.5828C4.18301 15.9085 4 16.3504 4 16.8111V20H7.18893C7.64964 20 8.09148 19.817 8.41724 19.4912L17.0282 10.8803M13.1197 6.9718L17.0282 10.8803"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
